import React from 'react';
import { BookmarkIcon as BookmarkOutline } from '@heroicons/react/24/outline';
import { BookmarkIcon as BookmarkSolid } from '@heroicons/react/24/solid';
import useBookmark from '../hooks/useBookmark';

export default function BookmarkButton({ type, id, className = '', size = 'md' }) {
  const { isBookmarked, toggleBookmark, loading } = useBookmark(type, id);

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
  };

  const handleClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      await toggleBookmark();
    } catch (error) {
      // Error already logged in hook
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`transition-all ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:scale-110'} ${className}`}
      title={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
    >
      {isBookmarked ? (
        <BookmarkSolid className={`${sizeClasses[size]} text-yellow-500`} />
      ) : (
        <BookmarkOutline className={`${sizeClasses[size]} text-gray-400 hover:text-yellow-500`} />
      )}
    </button>
  );
}
